import React from "react";
import { Container, Heading, ImageSwiper,Line,ButtonBase,ButtonDiv,ButtonHead,ButtonContainer,SubHeading,Content,Icon,Pane,InfoContainer,Button} from "./styles/business";

export default function Business({ children, ...restProps }) {
  return <Container {...restProps}> {children} </Container>;
}

Business.Heading = function BusinessHeading({ children, ...restProps }) {
  return <Heading {...restProps}>{children}</Heading>;
};

Business.ImageSwiper = function BusinessImageSwiper({children, ...restProps}){
  return <ImageSwiper {...restProps}>{children}</ImageSwiper>;
}

Business.Line = function BusinessLine({children, ...restProps}){
  return <Line {...restProps}>{children}</Line>
}

Business.Icon = function BusinessIcon({children, ...restProps}){
  return <Icon {...restProps}>{children}</Icon>
}

Business.Content = function BusinessContent({children, ...restProps}){
  return <Content {...restProps}>{children}</Content>
}

Business.SubHeading = function BusinessSubHeaing({children, ...restProps}){
  return <SubHeading {...restProps}>{children}</SubHeading>
}

Business.Pane = function BusinessPane({children, ...restProps}){
  return <Pane {...restProps}>{children}</Pane>
}

Business.InfoContainer = function BusinessInfoContainer({children, ...restProps}){
  return <InfoContainer {...restProps}>{children}</InfoContainer>
}

Business.ButtonContainer = function BusinessButtonContainer({children, ...restProps}){
  return <ButtonContainer {...restProps}>{children}</ButtonContainer>
}

Business.ButtonDiv = function BusinessButtonDiv({children, ...restProps}){
  return <ButtonDiv {...restProps}>{children}</ButtonDiv>
}

Business.ButtonHead = function BusinessButtonHead({children, ...restProps}){
  return <ButtonHead {...restProps}>{children}</ButtonHead>
}

Business.ButtonBase = function BusinessButtonBase({children, ...restProps}){
  return <ButtonBase {...restProps}>{children}</ButtonBase>
}

Business.Button = function BusinessButton({children, ...restProps}){
  return (
      <Button {...restProps}>
          {children}
      </Button>
  )
};